module.exports = __webpack_public_path__ + "static/media/up-arrow.3e190308.svg";